(function($) {
    site_url = wplc.siteurl;

    // Target main-navigation top-level items only
    // Add an event listener for clicks, to show a dropdown
    var menuItemLinksWithDropdowns = [];
    $('.health-main-navigation-nav-list > li.menu-item').each(function(i) {
        if ($(this).hasClass('menu-item-has-children')) {
            menuItemLinksWithDropdowns.push($(this).find("> a"));
            $(this).find("> a").click(function(e) {
                e.stopPropagation();
                e.preventDefault();
                toggleDropdown($(this));
            });
        }
    });

    // Toggles a dropdown given a top level jQuery element
    function toggleDropdown(jElem) {
        if (jElem.parent("li.menu-item").hasClass("dropdown-active")) {
            closeDropdown(jElem);
        } else {
            $.each(menuItemLinksWithDropdowns, function(index, value) {
                closeDropdown(value);
            });
            jElem.parent("li.menu-item").addClass('dropdown-active');
            jElem.parent("li.menu-item").children(".sub-menu").addClass('active');
        }
    }

    // Closes a dropdown given a top level jQuery element
    function closeDropdown(jElem) {
        jElem.parent("li.menu-item").removeClass('dropdown-active');
        jElem.parent("li.menu-item").children(".sub-menu").removeClass('active');
    }

    var mobileMenuItemLinksWithDropdowns = [];
    // Sets click events to each mobile menu nav item with children
    $('#shiftnav-main .shiftnav-menu > li.menu-item-has-children').each(function(i) {
        mobileMenuItemLinksWithDropdowns.push($(this).find("> a,> span"));
        $(this).find("> a,> span").click(function(e) {
            e.preventDefault();
            toggleMobileDropdown($(this));
        });
    });

    function toggleMobileDropdown(jElem) {
        if (jElem.parent("li.menu-item").hasClass("shiftnav-active")) {
            closeMobileDropdown(jElem);
        } else {
            $.each(mobileMenuItemLinksWithDropdowns, function(index, value) {
                closeMobileDropdown(value);
            });
            jElem.parent("li.menu-item").addClass("shiftnav-active");
            jElem.parent("li.menu-item").children(".sub-menu").addClass("shiftnav-sub-active");
        }
    }

    function closeMobileDropdown(jElem) {
        jElem.parent('li.menu-item').removeClass('shiftnav-active');
        jElem.parent('li.menu-item').children('.sub-menu').removeClass('shiftnav-sub-active');
    }

    // Register clicks outside of menus
    $('html').click(function() {
        $('.health-main-navigation-nav-list > li.menu-item.dropdown-active > a').each(function(i) {
            closeDropdown($(this));
        });
    });

    function mobileNavElementToString() {
        var result = '<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item shiftnav-depth-0">';
        result += '<a class="shiftnav-target" href="' + this.link + '">' + this.svg + this.name + '</a>';
        result += '</li>';
        return result;
    }

    function MobileNavElement(svg, link, name) {
        this.svg = svg;
        this.link = link;
        this.name = name;
        this.string = mobileNavElementToString;
    }

    // Adds content to mobile navigation
    function addCTAToMobileNav() {
        var appointment_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66.15 60.59" class="uchealth-mobile-nav-icon"><title>appointment</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="_Group_" data-name="&lt;Group&gt;"><path id="_Compound_Path_" data-name="&lt;Compound Path&gt;" d="M64.26,0H1.89A1.89,1.89,0,0,0,0,1.89V58.7a1.89,1.89,0,0,0,1.89,1.89H64.26a1.89,1.89,0,0,0,1.89-1.89V1.89A1.89,1.89,0,0,0,64.26,0ZM33.07,3.81a3.43,3.43,0,1,1-3.43,3.43A3.43,3.43,0,0,1,33.07,3.81Zm29.3,41.35c-.9,5.29-9.76,4.45-9.76,4.45.87,4.21-.62,7.2-2.82,7.2h-46V15.76h58.6Z"/><path id="_Path_" data-name="&lt;Path&gt;" d="M30.63,43.36H26.15V23.93H22.08a16.63,16.63,0,0,1-5.95,2.18v3.43h4.48V43.36h-5.2v4.48H30.63Z"/><path id="_Path_2" data-name="&lt;Path&gt;" d="M41.17,43.81A7.68,7.68,0,0,1,36,41.44l-2.49,3.5A11.35,11.35,0,0,0,42,48.3c4.67,0,8.77-3.05,8.77-8.36,0-5.08-3.5-7.42-7.61-7.42a6,6,0,0,0-2.67.57l.42-4.48h8.77V23.93H36.08L35.41,36l2.49,1.58a5.65,5.65,0,0,1,3.54-1.21,3.44,3.44,0,0,1,3.76,3.69C45.2,42.54,43.62,43.81,41.17,43.81Z"/></g></g></g></svg>';
        var provider_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73.97 67.94" class="uchealth-mobile-nav-icon"><title>provider</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path id="_Path_" data-name="&lt;Path&gt;" d="M70.78,49.17A11,11,0,0,0,67.62,47l0,4a7.7,7.7,0,0,1,.74.65A7.59,7.59,0,0,1,63,64.51a7.61,7.61,0,0,1-5.39-2.25A7.58,7.58,0,0,1,61,49.6v2.49a5.21,5.21,0,1,0,3.92,0V39a10.85,10.85,0,0,0-21.67-.72s0,11.52,0,11.52a10.33,10.33,0,0,1-20.67,0V44.93C33,43.73,41.25,33,41.25,20c0-8.53-3.51-14.07-10.41-16.55a4.18,4.18,0,1,0-1.19,3.74c5.21,1.95,7.68,6.09,7.68,12.81,0,11.66-7.5,21.15-16.71,21.15S3.92,31.64,3.92,20c0-6.73,2.47-10.87,7.68-12.81a4.18,4.18,0,1,0-1.18-3.74C3.51,5.91,0,11.45,0,20,0,33,8.21,43.73,18.67,44.93v4.85a14.25,14.25,0,0,0,28.5,0V39A6.94,6.94,0,0,1,61,39v7.11a11,11,0,1,0,9.74,3.08Z"/></g></g></svg>';
        var location_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 61.32" class="uchealth-mobile-nav-icon"><title>location</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path id="_Compound_Path_" data-name="&lt;Compound Path&gt;" d="M24,0A24,24,0,0,0,0,24c0,3.83.6,7.62,2.5,10.66,4.34,6.93,20,25.91,20,25.91a2,2,0,0,0,3.09,0s15.62-19,20-25.91c1.9-3,2.5-6.83,2.5-10.66A24,24,0,0,0,24,0Zm-.18,32.4A11.71,11.71,0,1,1,35.53,20.69,11.71,11.71,0,0,1,23.82,32.4Z"/></g></g></svg>';
        var myuconnhealth_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.01 71" class="uchealth-mobile-nav-icon"><title>myuconnhealth</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="_Group_" data-name="&lt;Group&gt;"><circle id="_Path_" data-name="&lt;Path&gt;" cx="30" cy="17.37" r="17.38"/><path id="_Path_2" data-name="&lt;Path&gt;" d="M34,71H60V61.17c0-14-13.43-22.07-30-22.07s-30,8-30,22.07V71H34Z"/></g></g></g></svg>';
        var search_icon = '<i class="fa fa-search uchealth-mobile-nav-icon align-middle"></i>';
        var url = $('link[rel="canonical"]').attr("href");
        
        var nav = '';
        var inner = '';

        if (document.getElementById('shiftnav-main') != null) {   
            nav = $('#shiftnav-main');
            inner = nav.find('.shiftnav-inner');
        } else {
            nav = $('#health-mmenu-nav');
            inner = nav.find('[id^=menu-]');   
        }

        var nav_elements = [
            new MobileNavElement(provider_svg, site_url + '/find-a-provider', 'Find a Provider'),
            new MobileNavElement(appointment_svg, site_url + '/request-an-appointment', 'Request an Appointment'),
            new MobileNavElement(location_svg, site_url + '/plan-your-visit/locations-and-directions', 'Find a Location'),
            new MobileNavElement(myuconnhealth_svg, site_url + '/access-mychart', 'Access myChart'),
            new MobileNavElement(search_icon, '/search', 'Search')
        ];
        
        var nav_markup = '<nav class="shiftnav-nav uchealth-mobile-nav"><ul class="shiftnav-menu shiftnav-targets-default shiftnav-targets-text-default shiftnav-targets-icon-default">';
        nav_elements.forEach(function(element) {
            nav_markup += element.string();
        });
        nav_markup += '</ul></nav>';
        inner.append(nav_markup);
    }
    addCTAToMobileNav();
})(jQuery);
// Initiates Google Translate button
function googleTranslateElementInit() {
    new google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: 'ar,de,el,es,fr,hi,it,pl,pt,ru,sq,vi,zh-CN,zh-TW',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE
    }, 'google_translate_navigation_element');
}